import React from 'react';

interface TimeSlotSelectorProps {
    selectedDate: Date | null;
    selectedTime: Date | null;
    setSelectedTime: (time: Date) => void;
    disabled?: boolean;
}

const TimeSlotSelector: React.FC<TimeSlotSelectorProps> = ({
    selectedDate,
    selectedTime,
    setSelectedTime,
    disabled = false
}) => {
    // Available time slots by weekday (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const availableSlots: { 
        [key: number]: { 
            morning: number[], 
            evening: number[] 
        } 
    } = {
        1: { // Monday
            morning: [10, 11],
            evening: [19, 20]
        },
        2: { // Tuesday
            morning: [10, 11],
            evening: [19, 20]
        },
        3: { // Wednesday
            morning: [10, 11],
            evening: [19, 20]
        },
        4: { // Thursday
            morning: [10, 11],
            evening: [21, 22]
        },
        5: { // Friday
            morning: [10, 11],
            evening: [19, 20]
        }
    };
    
    // Get time slots for selected date based on weekday
    const getTimeSlotsForDate = (date: Date): number[] => {
        const weekday = date.getDay();
        const slots = availableSlots[weekday];
        
        if (slots) {
            return [...slots.morning, ...slots.evening];
        }
        
        // No available slots for this weekday
        return [];
    };

    if (!selectedDate) {
        return (
            <div className="time-slots-placeholder">
                <p className="time-prompt">{`Silakan pilih tanggal terlebih dahulu`}</p>
            </div>
        );
    }

    return (
        <div className="time-slots">
            {getTimeSlotsForDate(selectedDate).map(hour => {
                const timeSlot = new Date(selectedDate);
                timeSlot.setHours(hour, 0, 0);
                const isSelected = selectedTime &&
                    selectedTime.getHours() === hour &&
                    selectedTime.getDate() === selectedDate.getDate();
                
                // Determine if this is a morning or evening slot
                const weekday = selectedDate.getDay();
                const slots = availableSlots[weekday];
                const isMorningSlot = slots && slots.morning.includes(hour);
                const timeLabel = isMorningSlot ? 'Pagi' : 'Malam';

                return (
                    <button
                        key={hour}
                        className={`time-slot ${isSelected ? 'selected' : ''}`}
                        onClick={() => !disabled && setSelectedTime(timeSlot)}
                        disabled={disabled}
                    >
                        {timeLabel} {`${hour}:00`}
                    </button>
                );
            })}
            {getTimeSlotsForDate(selectedDate).length === 0 && (
                <p className="time-prompt">No available time slots for this date</p>
            )}
        </div>
    );
};

export default TimeSlotSelector;